import { message } from "./message";
export const dateFormat1 = (timestamp) => {
	var date = new Date(timestamp * 1000); 
	var year = date.getFullYear();  
	var month = ("0" + (date.getMonth() + 1)).slice(-2); 
	var day = ("0" + date.getDate()).slice(-2);  
	var hour = ("0" + date.getHours()).slice(-2);  
	var minute = ("0" + date.getMinutes()).slice(-2);  
	var second = ("0" + date.getSeconds()).slice(-2);  
	var dateTimeString = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;  
	return dateTimeString;  
}

export const dateFormat2 = (timestamp) => {
	var date = new Date(timestamp * 1000); 
	var year = date.getFullYear();  
	var month = ("0" + (date.getMonth() + 1)).slice(-2); 
	var day = ("0" + date.getDate()).slice(-2);  
	var hour = ("0" + date.getHours()).slice(-2);  
	var minute = ("0" + date.getMinutes()).slice(-2);  
	var second = ("0" + date.getSeconds()).slice(-2);  
	var dateTimeString = year + "-" + month + "-" + day + " " + hour + ":" + minute ;  
	return dateTimeString;  
}

export const checkClientArray = (list) => {
	let has_phone = true
	let has_name = true
	list.forEach(item =>{
		if(!item.name){
			has_name = false
		}
		if(!item.phone){
			has_phone = false
		}
	})
	if(!has_name){ 
		return '客户姓名'
	}
	if(!has_phone){
		return '客户电话'
	}
	
}
export const checkSelectShow = (list) => {
	let array = []
	list.forEach(item =>{
		if(item.show_status == 1){
			array.push(item)
		}
	})
	return array	
}

export const selectFind = (list,id) => {
	if(!Array.isArray(list)){
		list = []
	}
	let array = []
	array = list.find(item => item.type.id === id)?.options || []
	array.forEach(item =>{
		item.name = item.name ? item.name : item.title
		item.value = item.value ? item.value : item.title
		if(item.child && item.child.length > 0){
			item.child.forEach(val =>{
				val.name = val.name ? val.name : val.title
				val.value = val.value ? val.value : val.title
			})
		}
	})
	return array	
}

export const getItemName = (list,id) => {
	let name = ''
	list.forEach(item =>{
		if(item.id == id){
			name = item.name
		}
	})
	return name	
}
export const getItemId = (list,name) => {
	let id = ''
	list.forEach(item =>{
		if(item.name == name){
			id = item.id
		}
	})
	return id	
}